import { AreaPosition } from "type/panel/Panel.type";

export type GridCoordinates = {
  columnStart: number;
  columnEnd: number;
  rowStart: number;
  rowEnd: number;
};

export const gridCoordinatesGet = (area: AreaPosition): GridCoordinates => {
  const columnStart: number = area.columnStart + 1;
  const columnEnd: number = area.columnEnd + 1;
  const rowStart: number = area.rowStart + 1;
  const rowEnd: number = area.rowEnd + 1;

  // columnStart = columnStart + 1;
  // columnEnd = columnEnd + 2;
  // rowStart = rowStart + 1;
  // rowEnd = rowEnd + 2;

  const result: GridCoordinates = {
    columnStart,
    columnEnd,
    rowStart,
    rowEnd,
  };

  return result;
};

export const playAreaIdGet = (playMapInd: number, areaInd: number): string => {
  return `play_area_${playMapInd}_${areaInd}`;
};

export const elDimensionsGetById = (elId: string): any => {
  const el = document.getElementById(elId);
  const result = {
    offsetWidth: el?.offsetWidth,
    offsetHeight: el?.offsetHeight,
  };

  return result;
};
